export default __webpack_public_path__ + "static/media/TJ.d97c7732.svg";